<script lang="ts" generics="T">
  import { isNilOrEmpty, type ItemsResponse } from "@tastyworks/tastyworks-api"
  import LoadingSpinner from "./LoadingSpinner.svelte"

  let {
    promise,
    defaultMessage = "No content in table",
    noResultsMessage = "No results found",
  } = $props<{
    promise: Promise<ItemsResponse<T> | null>
    defaultMessage?: string
    noResultsMessage?: string
  }>()
</script>

{#await promise}
  <div class="relative h-full min-h-16 w-full min-w-16">
    <LoadingSpinner />
  </div>
{:then results}
  {#if !results}
    <div class="flex h-full w-full items-center justify-center">
      {defaultMessage}
    </div>
  {:else if isNilOrEmpty(results.items)}
    <div class="flex h-full w-full items-center justify-center">
      {noResultsMessage}
    </div>
  {:else}
    <slot
      items={results.items}
      pagination={results.pagination}
      isLastPage={results.isLastPage}
    ></slot>
  {/if}
{:catch error}
  <div class="flex h-full w-full items-center justify-center">
    {error.message}
  </div>
{/await}
